var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBannerSigningIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.819,
    height: 18.506,
    viewBox: "0 0 20.819 18.506",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-file-signature",
    "data-name": "Icon awesome-file-signature",
    d: "M7.886,15.33a.4.4,0,0,0-.368-.236.394.394,0,0,0-.362.224l-.277.554A.578.578,0,0,1,5.813,15.8L5.2,13.973l-.383,1.152a1.56,1.56,0,0,1-1.482,1.067H2.892a.578.578,0,1,1,0-1.157h.448a.405.405,0,0,0,.385-.277l.657-1.975a.868.868,0,0,1,1.646,0l.5,1.505a1.622,1.622,0,0,1,2.386.512.41.41,0,0,0,.338.226V12.059L13.88,7.466V5.783H8.964A.87.87,0,0,1,8.1,4.916V0H.867A.865.865,0,0,0,0,.867V17.638a.865.865,0,0,0,.867.867H13.012a.865.865,0,0,0,.867-.867V16.193l-4.626,0A1.552,1.552,0,0,1,7.886,15.33ZM13.879,4.406a.865.865,0,0,0-.253-.611L10.088.253A.867.867,0,0,0,9.473,0h-.22V4.626h4.626Zm-3.47,8.135v2.5H12.9l5.844-5.884L16.293,6.7,10.41,12.541Zm10.14-6.493L19.4,4.9a.921.921,0,0,0-1.3,0l-.985.985,2.453,2.453.985-.985A.92.92,0,0,0,20.549,6.048Z",
    fill: "#16d696"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerSigningIcon);
export default __webpack_public_path__ + "static/media/banner-signing-icon.e1778c8df486b15f5a81d160d5c6f73d.svg";
export { ForwardRef as ReactComponent };